// extracted by mini-css-extract-plugin
module.exports = {"changePassword":"ChangePassword_changePassword__10K8y","marginBottom":"ChangePassword_marginBottom__2B03f"};